module.exports = __webpack_public_path__ + "12f378f2a92906e8d4c0ea4d61d0bd26.svg";